export const SHOP_NAME = "CashFlow";
export const SHOP_ADDRESS = "No. 10 U/Kwari, Ladanai Quarters, Hotoro, Kano";
export const SHOP_PHONE = "07036313352";
export const SHOP_MOTTO = "Your Business Finances, in Hand";

export const HOSPITAL_NAME = "Hospify";
export const HOSPITAL_ADDRESS = "No. 10 U/Kwari, Ladanai Quarters, Hotoro, Kano";
export const HOSPITAL_PHONE = "07036313352";
export const HOSPITAL_MOTTO = "Healthcare, Simplified";

